import { useState } from "react";
import { CreateBoatDTO } from "../../../types/boat.types";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BoatsAPI } from "../../../APIs/boats.api";
import { useToast } from "../../../components/toast";
import BoatForm from "../../my-team/boat-information/boat-form";

export function BoatCreate() {
  const [searchParams] = useSearchParams();
  const teamId = searchParams.get("teamId");

  const [formData, setFormData] = useState<CreateBoatDTO>({
    name: "",
    registration_number: "",
    engine_brand: "",
    hp: 0,
    has_radio: false,
    is_yacht: false,
  });

  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { addToast } = useToast();

  function handleChange(e: React.ChangeEvent<HTMLElement>) {
    const target = e.target as HTMLInputElement;
    const { name, value, type, checked } = target;

    setFormData((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : type === "number"
          ? Number(value)
          : value,
    }));
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!teamId) {
      addToast({
        message: "Error: ID de equipo no encontrado",
        type: "error",
        location: "bottom-center",
      });
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await BoatsAPI.postBoatAdmin(formData, parseInt(teamId));
      if (response.statusCode === 201) {
        addToast({
          message: "¡Embarcación creada!",
          type: "success",
          location: "bottom-center",
        });
        navigate(`/dashboard/teams/view/${teamId}`);
      } else {
        addToast({
          message: response.message || "Error al crear la embarcación",
          type: "error",
          location: "bottom-center",
        });
      }
    } catch (error) {
      addToast({
        message: "Error al crear la embarcación, intente nuevamente",
        type: "error",
        location: "bottom-center",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    if (teamId) {
      navigate(`/dashboard/teams/view/${teamId}`);
    } else {
      navigate(-1);
    }
  };

  if (!teamId) {
    return (
      <div className="min-h-screen mt-10">
        <div className="max-w-2xl mx-auto p-6 bg-white rounded-lg shadow-md">
          <div className="text-center text-red-600">
            Error: ID de equipo no encontrado
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen mt-10">
      <div className="max-w-2xl mx-auto p-6 bg-white rounded-lg shadow-md">
        <BoatForm
          createBoat={formData}
          title="Crear Embarcación"
          buttonText="Crear"
          buttonVariant="create"
          isSubmitting={isSubmitting}
          onCancel={handleCancel}
          onSubmit={handleSubmit}
          handleChange={handleChange}
        />
      </div>
    </div>
  );
}
